import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useAuthStore } from "@/store/auth/login";
import { CategoryCost } from "@/store/expenses/category_costs";

import DataTable from "primevue/datatable";
import Column from "primevue/column";
import InputNumber from "primevue/inputnumber";


export default /*#__PURE__*/_defineComponent({
  __name: 'CoefficientsTable',
  props: {
    coefficients: {},
    isLoading: { type: Boolean }
  },
  emits: ["updateCoefficient"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const authStore = useAuthStore();

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(["expenses:edit"]);
});

const getLevelName = (level: string) => {
  return `Уровень ${level.toUpperCase()}`;
};

const onCostChange = (item: CategoryCost) => {
  emit("updateCoefficient", item);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DataTable), {
    value: _ctx.coefficients,
    class: "scroll-table-y main-table scrollbar-custom",
    stripedRows: "",
    loading: _ctx.isLoading,
    dataKey: "level"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Column), {
        field: "level",
        header: "Уровень категории",
        style: {"min-width":"200px"}
      }, {
        body: _withCtx((slotProps) => [
          _createTextVNode(_toDisplayString(getLevelName(slotProps.data.level)), 1)
        ]),
        _: 1
      }),
      _createVNode(_unref(Column), {
        field: "cost",
        header: "Коэффициент",
        style: {"min-width":"200px"}
      }, {
        body: _withCtx((slotProps) => [
          _createVNode(_unref(InputNumber), {
            modelValue: slotProps.data.cost,
            "onUpdate:modelValue": [($event: any) => ((slotProps.data.cost) = $event), ($event: any) => (onCostChange(slotProps.data))],
            disabled: isDenied.value,
            mode: "decimal",
            min: 0,
            maxFractionDigits: 2,
            useGrouping: false,
            class: "coefficient-input"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["value", "loading"]))
}
}

})